import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Props
// 0) style (object)
// 1) status (boolean)
// 2) status_code (string)
// 3) description (string)
// 4) icon_margin (string) ex) "56px"

class ResultBox extends Component {
  render() {
    return (
      <this.BoxLayout style={this.props.style}>
        { /* Success / error icon */}
        { this.props.status === false ? <this.ErrorIcon /> : <this.SuccessIcon />}
        {/* Success / error code */}
        { this.props.status === false
        ? <this.ErrorCode> {this.props.status_code} </this.ErrorCode>
        : <this.SuccessCode> {this.props.status_code} </this.SuccessCode> }
        {/* Success / error description */}
        <this.Description>
          {this.props.description}
        </this.Description>
        {/* Augmented fields */}
        {this.props.children}
      </this.BoxLayout>
    );
  }
  /* Style components */
  BoxLayout = styled.div`
    width: 100%;
    background-color: #FAFAFA;
    display: inline-block;
    text-align: center;
    overflow-y: scroll;
    line-height: 1;
  `;
  SuccessIconSvg = styled.svg`
    width: 80px;
    height: 80px;
    margin-top: 28px;
    filter: var(--success-svg-filter);
    margin-top: ${this.props.icon_margin};
  `;
  ErrorIconSvg = styled.svg`
    width: 80px;
    height: 80px;
    margin-top: 28px;
    filter: var(--error-svg-filter);
    margin-top: ${this.props.icon_margin};
  `;
  SuccessIcon = () => <this.SuccessIconSvg xmlns="http://www.w3.org/2000/svg"
    width="24" height="24" viewBox="0 0 24 24">
    <path fill="none" d="M0 0h24v24H0V0zm0 0h24v24H0V0z" />
    <path d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
  </this.SuccessIconSvg>;
  ErrorIcon = () => <this.ErrorIconSvg xmlns="http://www.w3.org/2000/svg"
    width="24" height="24" viewBox="0 0 24 24">
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
  </this.ErrorIconSvg>
  SuccessCode = styled.div`
    /* var(--font) 와 var(--success-color) 는 public/index.html 에 정의됨 */
    font-family: var(--font);
    font-weight: 300;
    font-size: 24px;
    color: var(--success-color);
    line-height: 1;
    margin: 24px 32px 0 32px;
  `;
  ErrorCode = styled.div`
    font-family: var(--font);
    font-weight: 300;
    font-size: 24px;
    color: var(--error-color);
    line-height: 1;
    margin: 24px 32px 0 32px;
  `;
  Description = styled.div`
    font-family: var(--font);
    font-weight: 300;
    font-size: 16px;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.6);

    margin-top: 12px;
    margin-left: 32px;
    margin-right: 32px;
    margin-bottom: 28px;
  `;
}

ResultBox.propTypes = {
    style: PropTypes.object,
    status: PropTypes.bool,
    status_code: PropTypes.string,
    description: PropTypes.string,
    icon_margin: PropTypes.string
}

ResultBox.defaultProps = {
    status: false,
    status_code: 'SUCCESS OR ERROR CODE',
    description: "Description here ...",
    icon_margin: "28px"
}

export default ResultBox;